/**
 * [経度, 緯度]になっている場合、[緯度, 経度]として返却
 * 【日本で使用する前提】
 * @param location
 * @returns location
 *
 * @see Impediment 2142: 緯度経度の順番を揃える（CMN）
 * TODO: DBの不整合のために必要な処理らしい。上記のチケットが解消されたら本処理は削除する
 */
export const checkLocationAndReverse = (location: [number, number]): [number, number] => {
  if (location[0] > location[1]) {
    return [location[1], location[0]]
  }
  return location
}
